import Vue from 'vue'
import Vuex from 'vuex'
import {ColeccionLanding, ColeccionLandingImagenes, storage} from '@/FirebaseConfig'
Vue.use(Vuex)
export default {
    namespaced:true,
    state:{
      contenido: {
        Bienvenido: { título: 'bienvenido' },
      },
      cargando: false,
      número: 0,
      lista_de_imagenes: [],
      tipos: [
        'Texto',
        'Arreglo',
        'Objeto',
      ]
    },
    actions:{
      obtener:({state})=>{
        state.cargando = true
        ColeccionLanding.onSnapshot(doc=>{
          if(doc.exists) state.contenido = doc.data()
          state.cargando = false
        })
        ColeccionLandingImagenes.onSnapshot(doc=>{
          if(doc.exists) state.lista_de_imagenes = doc.data().lista
        })
      },

      actualizar:({state,commit})=>{
        ColeccionLanding.set(state.contenido).then(()=>commit('Ayudas/launchSnackbar','Actualizado' , { root: true }))
      },

      guardar_imagen: ( {state}, contenido) => {
        state.lista_de_imagenes.push(contenido)
        ColeccionLandingImagenes.set({lista: state.lista_de_imagenes}) 
      },

      eliminar_imagen: ({state}, nombre) => {
        storage.ref('landing_page').child(nombre).delete().then(() => ColeccionLandingImagenes.set({lista: state.lista_de_imagenes.filter(item=>item.nombre != nombre)}) 
        ).catch( error => {
          console.log(error)
        })
      }
     
    },
    getters:{
      contenido: state => state.contenido,
      imágenes: state => state.lista_de_imagenes
    }
}
